import { getParachuteAuthToken } from '../utils/parachuteAuthToken';

/** Bearer headers for `/api/pct/v1` JSON endpoints. Returns null when not signed in. */
export async function pctBearerHeaders(): Promise<HeadersInit | null> {
  const token = getParachuteAuthToken();
  if (!token) return null;
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
}

/** Throws with API `message` or a fallback when the response is not ok. */
export async function pctEnsureOk(res: Response, fallback: string): Promise<void> {
  if (res.ok) return;
  let message = fallback;
  try {
    const json = (await res.json()) as { message?: string };
    if (typeof json?.message === 'string' && json.message.trim()) {
      message = json.message.trim();
    } else {
      message = `${fallback} (${res.status})`;
    }
  } catch {
    message = `${fallback} (${res.status})`;
  }
  throw new Error(message);
}
